
import React from 'react';
import { usePreferredBackground } from '@/hooks/usePreferredBackground';

interface BackgroundDebugProps {
  isVisible: boolean;
}

// Type guard to check if background info has Unsplash-specific properties
const hasUnsplashProperties = (backgroundInfo: any): backgroundInfo is {
  queryUsed?: string;
  debugInfo?: {
    totalResults: number;
    selectedIndex: number;
    hashSeed: string;
  };
  location?: {
    title?: string;
    name?: string;
    city?: string;
    country?: string;
  };
} => {
  return backgroundInfo && typeof backgroundInfo === 'object';
};

const BackgroundDebug: React.FC<BackgroundDebugProps> = ({ isVisible }) => {
  const { backgroundInfo } = usePreferredBackground();

  if (!isVisible || !backgroundInfo) return null;

  const unsplashInfo = hasUnsplashProperties(backgroundInfo) ? backgroundInfo : null;

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-75 text-white p-3 rounded-lg text-xs max-w-sm z-50">
      <h4 className="font-bold mb-2">Background Debug Info</h4>
      <div className="space-y-1">
        <div><strong>Time Slot:</strong> {backgroundInfo.timeSlot}</div>
        <div><strong>Date:</strong> {backgroundInfo.date}</div>
        <div><strong>Photographer:</strong> {backgroundInfo.photographer}</div>
        {unsplashInfo?.queryUsed && (
          <div><strong>Query:</strong> {unsplashInfo.queryUsed}</div>
        )}
        {unsplashInfo?.debugInfo && (
          <>
            <div><strong>Results:</strong> {unsplashInfo.debugInfo.totalResults}</div>
            <div><strong>Selected:</strong> #{unsplashInfo.debugInfo.selectedIndex}</div>
            <div><strong>Seed:</strong> {unsplashInfo.debugInfo.hashSeed}</div>
          </>
        )}
        {backgroundInfo.location && (
          <div><strong>Location:</strong> {
            ('title' in backgroundInfo.location && backgroundInfo.location.title) ||
            (unsplashInfo?.location?.name) || 
            (unsplashInfo?.location?.city) || 
            (unsplashInfo?.location?.country) || 
            'Unknown'
          }</div>
        )}
      </div>
    </div>
  );
};

export default BackgroundDebug;
